import PipeIcon from './component.jsx'
export default PipeIcon
